export const initImageSwitcher = () => {
  const containers = document.querySelectorAll('.js-image-switcher');

  containers.forEach((container) => {
    const mainImg = container.querySelector('.photo');
    const thumbs = container.querySelectorAll('.thumb');
    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (!src) return;

        mainImg.src = src;
        thumbs.forEach((t) => t.classList.remove('-active'));
        thumb.classList.add('-active');
      });
    });
  });
};
